import { render, staticRenderFns } from "./FormData.vue?vue&type=template&id=05821b2c&scoped=true"
import script from "./FormData.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormData.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FormData.vue?vue&type=style&index=0&id=05821b2c&prod&scoped=true&lang=scss"
import style1 from "./FormData.vue?vue&type=style&index=1&id=05821b2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05821b2c",
  null
  
)

export default component.exports